import React, { useState, useEffect } from "react";
import { getCurrentDate } from "../../Utilitie";
import { FaEraser, FaUpload } from "react-icons/fa";
import Loading from "../../Extra/Loading";
import { MdInsertChart } from "react-icons/md";
import SuccessMsg from "../../Extra/SuccessMsg";
import FailedMsg from "../../Extra/FailedMsg";
import axios from "axios";

const InterChangeUpdate = () => {
  const urlPrefix = process.env.REACT_APP_URL_PREFIX;

  const currentDate = getCurrentDate();
  const [interChangeData, setInterChangeData] = useState([]);

  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [globalDate, setGlobalDate] = useState(currentDate);
  const [show, setShow] = useState(false);

  const [gridData, setGridData] = useState([]);
  const [error, setError] = useState(false);
  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${urlPrefix}getinterchangedata?date=${globalDate}`
      );
      if (response.data.status === "ok") {
        setInterChangeData(response.data.data);
      }
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch stations:", error);
      setLoading(false);
      setError(true);
    }
  };
  useEffect(() => {
    fetchData();
  }, [globalDate]);
  const columnHead = [
    `IC_DATE`,
    `WGN_TO`,
    `WGN_HO`,
    `WGN_TRSN`,
    `TRAIN_TO`,
    `TRAIN_HO`,
    `TRAIN_TRSN`,
    `T_FC`,
    `FC_FAIL`,
    `WTR`,
    `DWB`,
    `LDG`,
    `UNLDG`,
    `AVG_SPEED`,
    `SPEED_Exclud_Stable`,
    `SPEED_Includ_Stable`,
    `BCN_HOLDING`,
    `E_BCN_HOLDING`,
    `L_BCN_HOLDING`,
    `BOXN_HOLDING`,
    `E_BOXN_HOLDING`,
    `L_BOXN_HOLDING`,
    `LDD_RECD`,
    `EFF_DWB`,
    `SICK`,
    `ROH`,
    `POH`,
    `DEPT`,
    `TOTAL_INEF`,
  ];
  useEffect(() => {
    const filtered = (interChangeData || []).filter(
      (row) => row.IC_DATE && String(row.IC_DATE).slice(0, 10) === globalDate
    );
    setGridData(filtered);
  }, [interChangeData, globalDate]);

  const handleChange = (rowIndex, key, value) => {
    const newData = [...gridData];
    newData[rowIndex][key] = value;
    setGridData(newData);
  };

  const sendToBackend = async () => {
    const finalData = gridData.map(
      ({
        IC_DATE,

        ...rest
      }) => rest
    );
    try {
      const response = await fetch(`${urlPrefix}interchangeupdate`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ records: finalData }),
      });
      if (!response.ok) {
        alert("Something went wrong");
        throw new Error("Network response was not ok");
      }

      await response.json();
      alert("success");
      setGlobalDate(new Date().toISOString().slice(0, 10));
    } catch (err) {
      console.error("Submission error:", err);
      setError(true);
    }
  };

  return (
    <div className="text-center mt-12">
      <div className="papaDiv text-start">
        <h4>
          <MdInsertChart />
          Interchange
        </h4>
        <h5 className="ps-2">
          Update data in table <b style={{ color: "red" }}>"t_interchange"</b>
        </h5>
      </div>

      <div className="my-3">
        Select Date:{" "}
        <input
          type="date"
          value={globalDate}
          max={currentDate}
          onChange={(e) => setGlobalDate(e.target.value)}
        />
      </div>

      <div className="table-responsive">
        <table
          className="table table-striped table-hover"
          border="1"
          cellPadding="1"
        >
          <thead>
            <tr className="table-dark" style={{ fontSize: "12px" }}>
              {columnHead.map((head, index) => (
                <th key={index} style={{ border: "1px solid gray" }}>
                  {head}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {gridData.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {columnHead.map((col, colIndex) => (
                  <td key={colIndex} style={{ border: "1px solid gray" }}>
                    {col === "IC_DATE" ? (
                      <input
                        disabled
                        type="date"
                        value={
                          row[col]?.slice(0, 10) || globalDate?.slice(0, 10)
                        }
                        max={currentDate}
                        onChange={(e) =>
                          handleChange(rowIndex, col, e.target.value)
                        }
                      />
                    ) : (
                      <input
                        type="text"
                        value={row[col] || ""}
                        style={{ width: "80px" }}
                        onChange={(e) =>
                          handleChange(rowIndex, col, e.target.value)
                        }
                      />
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="p-3">
        {result?.insertion ? (
          <SuccessMsg
            head="Success"
            message={result?.message}
            show={show}
            setShow={setShow}
          />
        ) : (
          result && (
            <FailedMsg
              head="Failed"
              message={`${result?.message || ""}, ${result?.error || ""}`}
              show={show}
              setShow={setShow}
            />
          )
        )}
      </div>

      <div>
        <button
          className={`m-1 btn btn-sm btn-outline-success ${
            loading ? "disabled" : ""
          }`}
          onClick={sendToBackend}
        >
          <FaUpload /> Upload
        </button>
        {loading && <Loading />}
      </div>
    </div>
  );
};

export default InterChangeUpdate;
